import { Box, Chip, Grid, TextField, Typography } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';
import { dollarFormatter, percentageFormatter } from '../utils';

const CollectReceiptDetails: React.FC<{
  tip: string;
  setTip: Dispatch<SetStateAction<string>>;
  total: string;
  setTotal: Dispatch<SetStateAction<string>>;
  getReceiptSubtotal: () => number;
  getGrandTotal: () => number
}> = ({ tip, setTip, total, setTotal, getReceiptSubtotal, getGrandTotal }) => {
  
  const getTaxPercentageDecimal = () => {
    if (getReceiptSubtotal() === 0 || total.trim().length === 0) return 0;
    return parseFloat(total) / getReceiptSubtotal() - 1;
  };

  const getTipPercentageDecimal = () => {
    if (getReceiptSubtotal() === 0 || tip.trim().length === 0) return 0;
    return parseFloat(tip) / getReceiptSubtotal();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        gap: '16px',
        width: '100%',
      }}
    >
      <Grid container>
        <Grid
          item
          xs={4}
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Typography> Subtotal </Typography>
        </Grid>
        <Grid
          item
          xs={8}
        >
          <Typography>{dollarFormatter(getReceiptSubtotal())}</Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid
          item
          xs={4}
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Typography> Tax </Typography>
        </Grid>
        <Grid
          item
          xs={8}
        >
          <Typography>
            {percentageFormatter(getTaxPercentageDecimal())}
          </Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid
          item
          xs={4}
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Typography> Total: </Typography>
        </Grid>
        <Grid
          item
          xs={8}
          sx={{ display: 'flex', gap: '8px' }}
        >
          <Typography sx={{ display: 'flex', alignItems: 'center' }}>
            $
          </Typography>

          <TextField
            autoFocus
            value={total}
            onChange={(event) => {
              const newTotal = event.target.value;
              setTotal(newTotal);
            }}
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid
          item
          xs={4}
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Typography>
            Tip ({percentageFormatter(getTipPercentageDecimal())}):
          </Typography>
        </Grid>
        <Grid
          item
          xs={8}
          sx={{ display: 'flex', gap: '8px' }}
        >
          <Typography sx={{ display: 'flex', alignItems: 'center' }}>
            $
          </Typography>

          <TextField
            value={tip}
            onChange={(event) => {
              const newTip = event.target.value;
              setTip(newTip);
            }}
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid
          item
          xs={4}
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Typography> Total Paid </Typography>
        </Grid>
        <Grid
          item
          xs={8}
        >
          <Typography>{dollarFormatter(getGrandTotal())}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CollectReceiptDetails;
